const REMEMBER_ME_KEY = '7ea0bad8-888a-4523-ad81-3310702f4a31';
const TOKEN = '0f80e202-f5db-4524-bba9-b79eb82f8a91';
const EXPIRE_DATE = '2a97f61f-5bca-4120-8ba6-2fb5e0cd0d68';
const ROLE = '19e2f689-52c2-48c6-a919-d6763d26f7b5';
const USER_ID = '14bed01e-4f7f-4bcc-ad12-55d8d27ad9e0';
const USER_TYPE = '8181a6f9-5a97-4186-9a05-152d14300192';
const TOKEN_KEY1 = '20b0bc42-412c-';
const TOKEN_KEY2 = '-9694-02b1c14c88ac';
const USER_ID_KEY1 = '842d7c6';
const USER_ID_KEY2 = '36a5785';
const USER_NAME = 'c4c836b4-0184-456b-97a0-33d575c7cfe3';
const ELDER_HOME = 'e36f2c8a-863d-4bed-9f93-558ce399aaff';
const EMAIL = '10346fcc-6844-41ab-9efc-05fbd46d1fty';
const SUMMARY_SETTINGS = 'c94e0cb8-4537-4526-a629-4557adcf5953';

export const getRememberMe = () => {
	const value = localStorage.getItem(REMEMBER_ME_KEY);
	if (value !== null) {
		return value;
	} else {
		return 2;
	}
};

export const setRememberMe = key => {
	localStorage.setItem(REMEMBER_ME_KEY, key);
};

export const getAccessToken = () => {
	const value = localStorage.getItem(TOKEN);
	if (value) {
		const token = value.replace(TOKEN_KEY1, '').replace(TOKEN_KEY2, '');
		return token;
	} else {
		return value;
	}
};

export const setAccessToken = token => {
	localStorage.setItem(TOKEN, `${TOKEN_KEY1}${token}${TOKEN_KEY2}`);
};

export const getExpireTime = () => {
	return localStorage.getItem(EXPIRE_DATE);
};

export const setExpireTime = (type = 'superAdmin') => {
	const currentDate = new Date();
	const expDate = new Date(
		currentDate.getTime() +
			(type === 'superAdmin' ? 1000 * 60 * 20 : 1000 * 60 * 60 * 48),
	);
	localStorage.setItem(EXPIRE_DATE, `${expDate.getTime()}`);
};

export const getUserRole = () => {
	return localStorage.getItem(ROLE);
};

export const setUserRole = role => {
	localStorage.setItem(ROLE, role);
};

export const getUserId = () => {
	const value = localStorage.getItem(USER_ID);
	if (value) {
		const id = value.replace(USER_ID_KEY1, '').replace(USER_ID_KEY2, '');
		return id;
	} else {
		return value;
	}
};

export const setUserId = id => {
	localStorage.setItem(USER_ID, `${USER_ID_KEY1}${id}${USER_ID_KEY2}`);
};

export const getUserType = () => {
	return localStorage.getItem(USER_TYPE);
};

export const setUserType = type => {
	localStorage.setItem(USER_TYPE, type);
};

export const getUserName = () => {
	return localStorage.getItem(USER_NAME);
};

export const setUserName = name => {
	localStorage.setItem(USER_NAME, name);
};

export const getElderHomeId = () => {
	return localStorage.getItem(ELDER_HOME);
};

export const setElderHomeId = id => {
	localStorage.setItem(ELDER_HOME, id);
};

export const getUserEmail = () => {
	const email = localStorage.getItem(EMAIL);
	return email ? email : 'N/A';
};

export const setUserEmail = mail => {
	localStorage.setItem(EMAIL, mail);
};

export const setSummaryTemplateEnabled = value => {
	localStorage.setItem(SUMMARY_SETTINGS, JSON.stringify(value));
};

export const getSummaryTemplateEnabled = () => {
	const item = localStorage.getItem(SUMMARY_SETTINGS);
	return item ? JSON.parse(item) : false;
};

export const signOut = () => {
	localStorage.clear();
	window.location.reload();
};
